// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"14":"60bd162a","242":"60bd162a","362":"0b31ff4a","524":"0b31ff4a","698":"30bd8971","770":"7d158888","970":"60bd162a"}[chunkId] + ".chunk.css";
};